export enum TabType {
  BOOK = 'BOOK',
  LIFE = 'LIFE',
}
